export default "__VITE_ASSET__e631aa95__"